import { IApplicationContext } from '../../types/applicationContext';
import { ResponseError } from 'shared/errors';
import {
  TDeleteOfferFromFavoritesResponse,
  fetchDeleteOfferFromFavorites,
  TDeleteOfferFromFavoritesRequest,
} from 'shared/repositories/favorites/v1/delete-offer-from-favorites';

export const deleteFromFavorites = async (
  { httpApi, logger }: IApplicationContext,
  parameters: TDeleteOfferFromFavoritesRequest,
) => {
  try {
    const { response, statusCode }: TDeleteOfferFromFavoritesResponse = await fetchDeleteOfferFromFavorites({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'deleteFromFavorites',
        message: response.message || '',
        details: {
          errors: JSON.stringify(response.errors),
        },
      });
    }
  } catch (e) {
    logger.error(e, {
      domain: 'deleteFromFavorites',
      parameters: JSON.stringify(parameters),
    });
  }
};
